import React, {useEffect, useState} from "react";
import {Button, Card, Flex, message, Typography} from "antd";
import styled from "styled-components";
import {connect} from "react-redux";
import {withRouter} from "../../../../utils/services/with-router";
import {registerUserCities} from "../../../actions";
import {UserCities} from "../../../models";
import {useNavigate} from "react-router-dom";

const {Text} = Typography;

export const StyledCard = styled(Card)`
    position: fixed;
    bottom: 0;
    z-index: 999;
    width: 90%;
    border: none;
    box-shadow: -2px -4px 36px -26px rgba(0, 0, 0, 0.53);
    .ant-card-body{
        padding: 12px 12px;

    }
    left: 50%;
    transform: translateX(-50%);
    max-width: 425px; /* or 430px for larger phones */

    /* For actual mobile devices */
    @media (max-width: 425px) {
        max-width: 100%;
        left: 0;
        transform: none;
        border-radius: 0;
    }
`;

interface Props {
    registerUserCities: any;
    cities: number[];
}

function LocationFooter({registerUserCities , cities}: Props) {
    const [loading, setLoading] = useState<boolean>(false);
    const navigate = useNavigate();
    const _registerUserCities = () => {
        setLoading(true)
        let model : UserCities =
            {
                cityIds : cities.map((item:any) => item.id)
            }
        registerUserCities(model)
            .then((data: any) => {
                setLoading(false)
                if (data.payload != undefined) {
                    message.success('شهر با موفقیت ثبت شد')
                    navigate(-1);
                }
            })
            .catch((e: any) => {
            });
    };

    return (
        <StyledCard>
            <Flex justify={"end"}>
                <Button loading={loading} onClick={_registerUserCities} type={"primary"} size={"large"}> تایید</Button>
            </Flex>
        </StyledCard>
    );
}

export default connect(null, {registerUserCities})(withRouter(LocationFooter));
